<template>
    <div>
		<el-dialog
		  title="提示"
		  :visible.sync="dialog"
		  width="30%">
		  <span>您的用户信息不存在，以下是您的用户ID，请告知管理员您的ID</span>
		  {{userId}}
		</el-dialog>
        <div style="height: 80%;">
            <div style="display:inline-block;width:50%;text-align:center;vertical-align: top;height: 100%;margin-top: 8%;">
               <img src="@/assets/icon/left.png" style="width:80%;">
            </div>
            <div style="display:inline-block;width:42%;text-align:center;vertical-align: top;height: 100%;margin-top: 8%;">
              	<div>
					<img src="@/assets/icon/logo.png" style="width:50%;margin-top:15%;">
				</div>
				<div style="margin-top: 10%;">
					<!-- <el-button @click="login" type="primary" style="margin-right: 3%;width:70%;height: 50px;font-size:20px;" round>
						<i class="el-icon-message"></i>
						登录</el-button> -->
					<!-- <el-button @click="login" type="primary" style="margin-right: 3%;width:40%;height: 50px;font-size:20px;" round>
						<i class="el-icon-message"></i>
						邮箱登录</el-button> -->
					<el-button @click="weChatLogin" type="success" style="margin-left:3%;width:40%;height: 50px;font-size:20px;" round>
						<i class="el-icon-chat-dot-round"></i>
						企业微信登录</el-button>
				</div>
          <!--      <el-button icon="el-icon-s-promotion" id="auth" @click="checkLogin" type="primary" round 
				style="width:80%;height:70px;;margin-top:8%;font-size:30px;">登<span style="margin-left:8%;"></span>录</el-button> -->
            </div>
        </div>
    </div>
</template>
<script>
	import utils from '@/utils';
	export default {
		name: 'login',
		data() {
			return {
				dialog:false,
				userId:"",
			};
		},
		methods:{
			login:function(){
				utils.signIn();
			},
			weChatLogin(){
				utils.weChatLogin();
			},
		},
		mounted(){
			//校验是否是企业微信登录
			utils.checkWeChatLogin(this.$route.query).then((data) => {
				if(data.ifLogin != 2){
					this.$message({
						message: '企业微信登录失败，请重试',
						type: "info",
						duration: 2000
					});
				}else{
					if(data.userId == null){
						this.$message({
							message: '用户信息不存在，请联系管理员添加',
							type: "info",
							duration: 2000
						});
					}else{
						//获取用户姓名存入本地缓存
						localStorage.setItem("username",data.userName);
						localStorage.setItem("weChatUser",JSON.stringify(data));
						//存入登录类型
						localStorage.setItem("loginType",2);
						console.log("登录成功")
						window.location.href = utils.GetLogin() + "#/Welcome";
					}
					
				}
			})
			
			
		}
	}
</script>
<style>
</style>
